import styled from 'styled-components';

const Container = styled.div`
  ${({ placement, isSticky }) => {
    if (placement === 'blog') {
      return `
        width: 27px;
        position: ${isSticky ? 'sticky' : 'inherit'};
        top: 154px;
        margin-left: -55px;
        padding-right: 60px;
        float: right;

       img {
          height: auto;
          margin-bottom: 28px;
        }

        button {
          width: auto !important;
        }

        @media (max-width: 1335px) {
          padding-right: 0px;
          margin-left: -30px;
        }
    `;
    }

    if (placement === 'topLeftSticky') {
      return `
        width: 27px;
        position: ${isSticky ? 'sticky' : 'inherit'};
        top: 140px;
        margin-left: -85px;
        float: left;

        img {
          height: auto;
          margin-bottom: 27px;
        }

        button {
          width: auto !important;
        }

        @media (max-width: 1335px) {
          margin-left: -60px;
        }
    `;
    }

    if (placement === 'quote') {
      return `
        width: auto !important;
        align-items: center;

        img {
          margin-right: 25px !important;
        }

        @media (max-width: 1335px) {
          align-self: center;
          width: max-content !important;
        }
    `;
    }

    if (placement === 'inline') {
      return `
        align-items: center;

        img {
          margin-right: 0 !important;
          width: 44px !important;
        }

        @media (max-width: 1335px) {
          align-self: center;
          width: max-content !important;
        }
    `;
    }
  }}

  display: ${({ placement }) =>
    placement === 'quote'
      ? 'flex !important'
      : placement === 'mobile'
      ? 'none !important'
      : 'block !important'};

  img {
    height: 27px;
  }

  @media (max-width: 1536px) {
    display: ${({ placement }) =>
      placement === 'quote'
        ? 'flex !important'
        : placement !== 'mobile'
        ? 'none !important'
        : 'flex !important'};
    display: flex;
    width: 100%;
    align-items: center;
    float: none;
    gap: 20px;
    img {
      height: 22px;
      width: auto;
    }
  }

  @media (max-width: 540px) {
    gap: 8px;
  }
`;

export default Container;
